import { isNumber } from "lodash";
import { useEffect, useState } from "react";
import { gameServerApi } from "services/gameServerV2";

interface LevelAchievement {
    id: number;
    name: string;
    baseValue: number;
    targetValue: number;
    iconUrl: string;
    milestonesCount: number;
}

export interface LevelAchievementFormatted {
    id: number;
    name: string;
    icon: string;
    iconGray: string;
    time: string;
}

export const useGetAllLevelAchievement = () => {
    const [data, setData] = useState<LevelAchievementFormatted[]>([]);

    const handleFormatTime = (time: number) => {
        if (Boolean(!time) || isNaN(time)) {
            return "0 MINUTES";
        }
        const value = Math.floor(time / 60);
        if(value < 60) {
            return `${value} ${value > 1 ? "MINUTES" : "MINUTE"}`;
        }
        const hour = Math.floor(value / 60);
        return `${hour} ${hour > 1 ? "HOURS" : "HOUR"}`;
    };

    const handleFormatLinkImageGray = (url: string) => {
        return url.replace(/(\d+)/, 'Gray$1');
    }

    const handleFormatData = (
        data: LevelAchievement[]
    ): LevelAchievementFormatted[] => {
        const formattedData = data.map((item) => ({
            id: item.id,
            name: item.name,
            icon: item.iconUrl.split(".png")[0] + "_128x128.png",
            iconGray: handleFormatLinkImageGray(item.iconUrl)?.split(".png")[0] + "_128x128.png",
            time: handleFormatTime(item.baseValue),
        }));
        return formattedData;
    };

    useEffect(() => {
        const fetchData = async () => {
            const allLevels =
                await gameServerApi.user.getAllLevelAchievements();
            const formattedData = handleFormatData(
                allLevels?.data?.records as LevelAchievement[]
            );
            setData(formattedData);
        };
        fetchData();
    }, []);
    return {
        data,
    };
};
